import { useTranslation } from 'react-i18next';

import { Button, ModalsProvider } from '@speeki/global-ui-components';

import { Card } from '@components/molecules/Card/Card';
import { DefaultLayout } from '@components/templates/DefaultLayout/DefaultLayout';

import { getPath } from '@services/RouteService/paths';

import { BannerLink } from '@domains/auth/molecules/LoginBanner/LoginBanner.styled';

import {
    ButtonsWrapper,
    LoginMessagingContainer,
} from './LoginMessagingPage.styled';

export const LoginMessagingPageSm = () => {
    const { t } = useTranslation();
    return (
        <DefaultLayout
            contentPadding={{
                top: 16,
            }}
        >
            <LoginMessagingContainer>
                <Card testId="rDVtLhn">
                    <Card.Description>
                        {t('TO_SEE_YOUR_CASES')}
                    </Card.Description>
                    <Card.Description>
                        {t('TO_FOLLOW_YOUR_CASE')} {''}
                        <BannerLink to={getPath({ path: '/auth/signup' })}>
                            {t('CREATE_AN_ACCOUNT')}!
                        </BannerLink>
                    </Card.Description>
                </Card>
                <ButtonsWrapper>
                    <Button
                        fullWidth
                        onClick={() => ModalsProvider.open('MobileLoginModal')}
                        testId="button_login"
                        variant="primary"
                    >
                        {t('LOGIN')}
                    </Button>
                    <Button
                        fullWidth
                        onClick={() =>
                            ModalsProvider.open('MobileCaseStatusModal')
                        }
                        testId="button_check-case-status"
                        variant="secondary"
                    >
                        {t('CHECK_CASE_STATUS')}
                    </Button>
                </ButtonsWrapper>
            </LoginMessagingContainer>
        </DefaultLayout>
    );
};
